import {Component, OnInit} from '@angular/core';
import { AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import {AuthenticationService, DataService, ToastrService} from '../../_services/index';
import {ActivatedRoute, Router} from '@angular/router';
import * as _ from 'lodash';
import {environment} from '../../../environments/environment';
import {NgForm} from '@angular/forms';



@Component({
    selector: 'app-my-account',
    templateUrl: './my-account.component.html',
    styleUrls: ['./my-account.component.css'],
    providers: [ToastrService]
})
export class MyAccountComponent implements OnInit {
    mask: any[] = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    userProfile: any;
    isEditDisabled: boolean;
    isEmailEditDisabled: boolean;
    isPasswordEditDisabled: boolean;
    model: any = {};
    userEmail: string;
    unModifiedModel: any = {};
    countryList: Array<string>;
    stateList: Array<string>;
    zipcodeList: { Min: number; Max: number; State: string }[];
    whatBestDescribeYouList: Array<string>;
    isValidPostalCode = true;
    isValidState = true;
    isValidCountry = true;
    whatBestDescribesYou = true;


    constructor(private _activatedRoute: ActivatedRoute,
                private _router: Router,
                private _dataService: DataService,
                private _authenticationService: AuthenticationService,
                public _toastrService: ToastrService) {
        this.isEditDisabled = true;
        this.isEmailEditDisabled = true;
        this.isPasswordEditDisabled = true;
    }

    ngOnInit() {
        this.userProfile = this._authenticationService.getUserInfo();
        // console.log(this.userProfile);
        this.getUserAccountDetails(this._authenticationService.getUserID());
        this.countryList = this._dataService.getCountries();
        this.whatBestDescribeYouList = this._dataService.getWhatBestDescribesYou();
        this.zipcodeList = this._dataService.getZipcodes();
        this.stateList = this._dataService.getUSStates();

        /*Page's GA data */
        (<any>window).gtag('config', environment.gaId, {'page_path': `/my-account`});
    }

    onChange() {
        this.isEditDisabled = this.isEditDisabled === true ? false : true;
    }

    enableEmailEdit() {
        this.isEmailEditDisabled = this.isEmailEditDisabled === true ? false : true;
    }

    enablePasswordEdit() {
        this.isPasswordEditDisabled = this.isPasswordEditDisabled === true ? false : true;
    }

    getUserAccountDetails(userID) {
        const url = '/auth/userAccountDetails';
        // debugger;
        this._dataService.get(url + '/' + userID)
            .subscribe(
                (data: { data: Array<any>, response: string, response_message: Array<any> }) => {
                    if (data.response === 'success') {
                        this.model = JSON.parse(JSON.stringify(data.data));
                        console.log(this.model);
                        this.unModifiedModel = JSON.parse(JSON.stringify(data.data));
                        this.userEmail = this.unModifiedModel.email;
                    }
                },
                (error) => {
                    this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                });
    }

    onStateSelectionChange(val) {
        // Do something with selected state;
    }

    onSave(formElement: NgForm) {
        this.whatBestDescribesYou = true;
        this.isValidCountry = true;
        this.isValidState = true;
        this.isValidState = true;
        this.isValidPostalCode = true;
        const CountryValue = this.countryList.filter(obj => obj === formElement.form.value.country);
        const StateValue = this.stateList.filter(obj => obj === formElement.form.value.state);
        const DescribeValue = this.whatBestDescribeYouList.filter(obj => obj === formElement.form.value.what_best_describes_you);
        if (formElement.form.value.what_best_describes_you === 'null' || formElement.form.value.country === 'null' || formElement.form.value.country ===  '-------------' || DescribeValue.length === 0 || CountryValue.length === 0 || StateValue.length === 0 || formElement.form.value.state === 'null' || formElement.form.value.state === "---------") {
            if (formElement.form.value.what_best_describes_you === 'null' || DescribeValue.length === 0) {
                this.whatBestDescribesYou = false;
            }
            if (formElement.form.value.country === 'null' || formElement.form.value.country ===  '-------------' || CountryValue.length === 0)  {
                this.isValidCountry = false;
            }
            if (formElement.form.value.state === 'null' || formElement.form.value.state === "---------" || StateValue.length === 0)  {
                this.isValidState = false;
            }
            return;
        }

        if (this.model.country === 'United States') {
            const foundValue = this.zipcodeList.filter(obj => obj.State === formElement.form.value.state);
            if (foundValue.length > 0) {
                this.isValidState = true;
                const regExp = /[a-zA-Z]/g;
                const postal_code = formElement.form.value.postal_code;
                if (regExp.test(postal_code) || postal_code.length !== 5) {
                    this.isValidPostalCode = false;
                    return;
                } else {
                    if (foundValue[0].Min <= parseInt(postal_code) && parseInt(postal_code) <= foundValue[0].Max) {
                        this.isValidPostalCode = true;
                        console.log(foundValue);
                    } else {
                        this.isValidPostalCode = false;
                        return;
                    }
                }
            } else {
                this.isValidState = false;
                return;
            }
        }

        if (!formElement.form.valid)  {
            this._toastrService.typeCustomError('Please fill up the form details properly and try again.');
            return;
        }
        const modelData = this.model;
        const unModifiedmodelData = this.unModifiedModel;
        const url = '/auth/editUserAccount';
        const filteredBody = {};
        _.each(modelData, function (val, key) {
            if (modelData[key] !== unModifiedmodelData[key]) {
                filteredBody[key] = val;
            }
        });
        if (_.isEmpty(filteredBody)) {
            this._toastrService.typeCustomError('Nothing to update');
            return;
        } else {
            const body = {
                'userID': this._authenticationService.getUserID(),
                'changeType': 'account',
                profile: filteredBody
            };
            this._dataService.put(url, body)
                .subscribe(
                    (data: { data: any, response: string, response_message: Array<any> }) => {
                        if (data.response === 'success') {
                            this._toastrService.typeCustomSuccess(data.response_message);
                            this.getUserAccountDetails(this._authenticationService.getUserID());
                            this.isEditDisabled = true;
                        }
                    },
                    (error) => {
                        this._toastrService.typeCustomError(error.error.response_message || error.status_text);
                    });
        }
    }

    cancelEditing() {
        this.isEditDisabled = true;
        this.model = JSON.parse(JSON.stringify(this.unModifiedModel));
    }
}



// WEBPACK FOOTER //
// ./public/app/modules/my-account/my-account.component.ts